import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { env } from 'src/environments/env'
import { SK } from './util.service'
import { Platform } from '@ionic/angular'
import { StorageService } from './storage.service'
import OneSignal from 'onesignal-cordova-plugin';

export enum PUSH_TYPE {
  DIRECT_MESSAGE = 'direct_message',
  SERIE_NEW = 'serie_new',
  SOCIAL_NEW = 'social_new',
  COMMENT_SERIE_FOLLOW = 'comment_serie_follow',
  REPLY_COMMENT = 'reply_comment',
  LIKE_COMMENT = 'like_comment',
  SOCIAL_NEWS = 'social_news',
}

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsService {
  constructor(
    // private oneSignal: OneSignal,
    private storage: StorageService,
    private router: Router,
    public platform: Platform,
  ) {}
  oneSignalId: string

  async setupOneSignal() {
    // this.oneSignal.startInit(env.oneSignalAppId, env.androidProjectId)
    // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None)

    // this.oneSignal.handleNotificationReceived().subscribe(() => {})
    // this.oneSignal.handleNotificationOpened().subscribe(async (resp) => {
    //   const data = resp.notification.payload.additionalData
    //   const type: PUSH_TYPE = data.type
    //   switch (type) {
    //     case PUSH_TYPE.SOCIAL_NEW:
    //       this.router.navigateByUrl('/main/tabs/account&launchNews=true')
    //       break
    //     case PUSH_TYPE.SOCIAL_NEWS:
    //       this.router.navigateByUrl('/main/tabs/account&launchNews=true')
    //       break
    //     case PUSH_TYPE.COMMENT_SERIE_FOLLOW:
    //       this.router.navigateByUrl(
    //         `/comments/comment/${data.commentId}?chapterId=${data.chapterId}&volumeId=${data.volumeId}&serieId=${data.serieId}`,
    //       )
    //       break
    //     case PUSH_TYPE.REPLY_COMMENT:
    //       this.router.navigateByUrl(
    //         `/comments/comment/${data.commentId}?chapterId=${data.chapterId}&volumeId=${data.volumeId}&serieId=${data.serieId}`,
    //       )
    //       break
    //     case PUSH_TYPE.LIKE_COMMENT:
    //       this.router.navigateByUrl(
    //         `/comments/comment/${data.commentId}?chapterId=${data.chapterId}&volumeId=${data.volumeId}&serieId=${data.serieId}`,
    //       )
    //       break
    //   }
    // })
    // this.oneSignal.getIds().then(async (info) => {
    //   this.oneSignalId = info.userId
    //   await this.storage.set(SK.ONE_SIGNAL_ID, this.oneSignalId)
    // })
    // this.oneSignal.endInit()
  }

  getOneSignalId(): string {
    return this.oneSignalId
  }
}
